import React from 'react';

/**
 * Shared page header used by list views (Inbox, Todos, Notes, Memory).
 * Title + optional subtitle on the left, optional action slot on the right.
 */

interface PageHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  right?: React.ReactNode;
}

export function PageHeader({ title, subtitle, right }: PageHeaderProps) {
  return (
    <header
      style={{
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        gap: 16,
        marginBottom: 28,
      }}
    >
      <div style={{ minWidth: 0 }}>
        <h1
          style={{
            fontFamily: 'var(--font-display)',
            fontSize: 34,
            fontWeight: 600,
            letterSpacing: '-0.9px',
            lineHeight: 1.1,
            color: 'var(--ink)',
            margin: 0,
          }}
        >
          {title}
        </h1>
        {subtitle && (
          <div
            style={{
              color: 'var(--ink-soft)',
              fontSize: 14.5,
              marginTop: 6,
              lineHeight: 1.5,
            }}
          >
            {subtitle}
          </div>
        )}
      </div>
      {right && <div style={{ flexShrink: 0 }}>{right}</div>}
    </header>
  );
}
